/** THIS FILE IS AUTOGENERATED. DO NOT EDIT. */
import { IconProps } from "../types";
const CheckIcon = ({
  size = 24,
  ...props
}: IconProps) => {
  return <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24" width={size} height={size} {...props}><path fillRule="evenodd" d="M20.055 4.418a1 1 0 0 1 .277 1.387l-9 13.5a1 1 0 0 1-1.54.152l-6-6a1 1 0 1 1 1.415-1.414l5.138 5.137 8.323-12.485a1 1 0 0 1 1.387-.277" clipRule="evenodd" /></svg>;
};
export default CheckIcon;